// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (min-width:750px){h2[data-v-7d0fc1e8]{font-style:normal;height:0.34rem;font-size:0.36rem;font-weight:500;color:#333;line-height:0.34rem;text-align:center}}@media screen and (max-width:750px){h2[data-v-7d0fc1e8]{font-style:normal;font-size:0.36rem;color:#333;letter-spacing:0;text-align:center;line-height:normal;font-weight:500}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
